
<div *ngIf="showRequest">
  <!--load shipyard request read only-->
  <h2 class="sectionTitle">{{ 'FRONT_USER.ADMIN_DECISION_FORM.USER_DECISION' | translate }}</h2>

  <app-admin-decision [IsReadOnly]="readonly"></app-admin-decision>
  <div *ngIf="!isRequestHistory">
    <div [class.read-only-content]="IsReadOnly">
      <form [formGroup]="UserDecisionForm" (ngSubmit)="onSubmit()">
        <fieldset class="form-container">
          <!-- user Decision where admin dicision in  View mode  -->
          <h4 class="section-title">{{ 'FRONT_USER.DECISION' | translate }}</h4>
          <div class="form-group">
            <label >
              {{ 'FRONT_USER.ADMIN_DECISION_FORM.DECISION' | translate }}</label>
            <span class="red"> *</span>
            <div class="form-custom-inputs">
              <div *ngFor="let currDecision of ternaryDecisionKeys;let i='index'" class="custom-Radio">
                <input type="radio" [id]="'TDecision' + currDecision"
                  (change)="userDecisionChoice(ternaryDecision[currDecision])"  name="TDecision"
                  formControlName="TDecision"  [value]="ternaryDecision[currDecision]"
                  *ngIf="ShowRequiredModificationDecision(i)" />
                <label [for]="'TDecision' + currDecision"
                  *ngIf="ShowRequiredModificationDecision(i)">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + currDecision | translate }}</label>
              </div>
            </div>
            <div *ngIf="submitted && Validate.TDecision?.errors" class="red ">
              <div *ngIf="Validate.TDecision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            </div>

          </div>

          <div class="form-group" *ngIf="isRejected">
            <label
              for="UserRejectionReasons">{{ 'FRONT_USER.ADMIN_DECISION_FORM.USER_REJECTION_REASONS' | translate }}</label>
              <span class="red"> *</span>
            <textarea class="form-control" id="UserRejectionReasons" name="UserRejectionReasons"
              formControlName="UserRejectionReasons"></textarea>
              <div *ngIf="submitted && Validate.UserRejectionReasons?.errors" class="red ">
                  <div *ngIf="Validate.UserRejectionReasons?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                </div>
            </div>

          <div class="form-group" *ngIf="isRequiredModifications">
            <label
              for="UserRequiredModifications">{{ 'FRONT_USER.ADMIN_DECISION_FORM.USER_REQUIRED_MODIFICATIONS' | translate }}</label>
            <span class="red"> *</span>
            <textarea class="form-control" id="UserRequiredModifications" name="UserRequiredModifications"
              formControlName="UserRequiredModifications"></textarea>
            <div *ngIf="submitted && Validate.UserRequiredModifications?.errors" class="red">
              <div *ngIf="Validate.UserRequiredModifications?.errors?.required">
                {{ 'FRONT_USER.ADMIN_DECISION_FORM.USER_REQUIRED_MODIFICATIONS_ERROR' | translate }}
              </div>
            </div>
          </div>

          <button Confirmation (confirmationClick)="userResponse()" [disabled]="loading" class="btn btn-primary SCAcustomBtn"
            >{{ 'FRONT_USER.SAVE' | translate }}</button>
        </fieldset>
      </form>
    </div>
  </div>


  <div *ngIf="isRequestHistory">
    <fieldset [disabled]="true">
      <div [class.read-only-content]="IsReadOnly">
        <form [formGroup]="UserDecisionForm" >
          <fieldset class="form-container">
            <!-- user Decision where admin dicision in  View mode  -->
            <h4 class="section-title">{{ 'FRONT_USER.DECISION' | translate }}</h4>
            <div class="form-group">
              <label >
                {{ 'FRONT_USER.ADMIN_DECISION_FORM.DECISION' | translate }}</label>

              <div class="form-custom-inputs">
                  <div class="custom-Radio">
                      <input  type="radio" [checked]="userAccept" />
                      <label>{{'FRONT_USER.ADMIN_DECISION_FORM.Accept'| translate }}</label>
                    </div>
                <div class="custom-Radio">
                  <input  type="radio" [checked]="userIsReject" />
                  <label>{{'FRONT_USER.ADMIN_DECISION_FORM.Reject'| translate }}</label>
                </div>
                <div class="custom-Radio">
                    <input  type="radio" [checked]="userIsRequireModification" />
                    <label>{{'FRONT_USER.ADMIN_DECISION_FORM.RequiredModifications' |translate}}</label>
                  </div>
              </div>


            </div>

            <div class="form-group" *ngIf="userIsReject">
              <label
                for="UserRejectionReasons">{{ 'FRONT_USER.ADMIN_DECISION_FORM.USER_REJECTION_REASONS' | translate }}</label>
              <textarea class="form-control" id="UserRejectionReasons" name="UserRejectionReasons"
                formControlName="UserRejectionReasons" value="{{rejectionReasons}}"></textarea>
            </div>


            <div class="form-group" *ngIf="userIsRequireModification">
              <label
                for="UserRequiredModifications">{{ 'FRONT_USER.ADMIN_DECISION_FORM.USER_REQUIRED_MODIFICATIONS' | translate }}</label>
              <textarea class="form-control" id="UserRequiredModifications" name="UserRequiredModifications"
                formControlName="UserRequiredModifications" value = {{userRequireModification}}></textarea>

            </div>


          </fieldset>
        </form>
      </div>
    </fieldset>
  </div>

</div>




<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.ADMIN_DECISION_FORM.USER_SUCCESS_MESSAGE' | translate }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">{{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
      <i class="icon-error"></i>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

  </div>
</div>
